import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import {getWebsiteList} from '../../request/index/website'
import {getToken} from '../../request/common'

export default {
    namespaced: true,
    state: {
        // 网站列表
        listToken: '',
        listKeyWord: '',
        pageNum: 1,
        listData: {
            count: 0,
            list: [],
            time: 0
        },
        listHasUrlParam: false,
        listHasContent: false
    },
    mutations: {
        setList (state, payLoad) {
            state.keyWord = payLoad.kw
            state.pageNum = payLoad.pageNum
            state.listData = payLoad.data
        },
        setListKeyWord (state, kw) {
            state.listKeyWord = kw
        },
        setToken (state, token) {
            state.listToken = token
        },
        setListHasUrlParam (state, isOpen) {
            state.listHasUrlParam = isOpen
        },
        setListHasContent (state, isOpen) {
            state.listHasContent = isOpen
        }
    },
    actions: {
        // payLoad: kw, page
        getList (context, payLoad) {
            // 获取参数
            let webSiteSearchParams = {
                param: {keyword: payLoad.kw, page: payLoad.page},
                token: payLoad.token
            }
            // 请求接口
            return getWebsiteList(webSiteSearchParams.param, webSiteSearchParams.token).then(res => {
                if (res.success) {
                    // 将列表信息和搜索值传入store (这个接口就算返回值是空格式也是正确的,载荷为res.data与searchKw)
                    const payLoad = {
                        kw: webSiteSearchParams.param.keyword,
                        pageNum: webSiteSearchParams.param.pageNum,
                        data: res.data
                    }
                    context.commit('setList', payLoad)
                } else {
                    console.warn('获取企业列表失败')
                }
                return res
            })
        },
        getToken (context) {
            return getToken().then(res => {
                if (res.success) {
                    context.commit('setToken', res.data)
                }
                return res
            })
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/website.js